module.exports = __webpack_public_path__ + "static/img/quan_jiang.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/quan_jiang.jpg
// module id = jGqX
// module chunks = 0